/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable vars-on-top */
/* eslint-disable max-statements*/
/* eslint-disable  no-negated-condition */
/* eslint-disable  dollar-sign/dollar-sign */
(function() {
  var phLoaderClass = 'loader',
      $decisionpageCards = $('#decisionpageCards'),
      $intObs = $('.ph-intersection-observer'),
      oStock = 'ph-product__outofstock',
      addtocartButton = 'addtocartButton',
      decisionpageconfigbutton = 'ph-decisionpageconfigbutton',
      phlazyloadeditem = 'ph-lazyloaded-item',
      lazyDecisionItemId = 'decisionpageitem',
      lazyAddtoCart = 'addToCartButton',
      disableButton = 'ph-disable-button',
      cartDisable = 'ph-cart-disable',
      intersectionObserver = 'intersection-observer',
      lazyLoadIcon = 'ph-loader';


  ACC.decisionPageInfiniteLoader = {
    executeLoadContent: true,
    inStockChkBox: '#ph-filter-Availability',
    isChecked: 'checked',
    intObs: $('.ph-intersection-observer'),
    decPageItem: '.ph-decisionpage__item',
    phdflexCls: 'ph-d-flex',
    phdnoneCls: 'ph-d-none',
    productCards: '#decisionpageCards',
    categoryCode: '.ph-headerparent__categorycode',
    bindAll: function() {
      /* Commenting the intersection observer for lazy loading api for existing one
      if ($('.ph-searchresultpage').length > 0) {
        this.setObserver();
      }*/
    },
    setObserver: function() {
      var container = document.querySelector('.ph-' + intersectionObserver);

      // eslint-disable-next-line require-jsdoc
      function intersection() {
        /* eslint-disable compat/compat */
        var observer = new IntersectionObserver(function(entries) {
          /* eslint-enable compat/compat */
          entries.map(function(entry) {
            var isIntersecting = entry.isIntersecting;

            if (isIntersecting) {
              ACC.decisionPageInfiniteLoader.loadContentSmartly(container, observer);
              observer.observe(container);
            }

            return true;
          }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
          });
        });

        observer.observe(container);
      }

      if ('IntersectionObserver' in window) {
        intersection();
      } else {
        $.getScript(ACC.config.commonResourcePath + '/js/vendor/intersection-observer.min.js', function() {
          intersection();
        });
      }
    },
    categoryPageJsonPath: function(pageLengths) {
      var categoryJsonUrl = '',
          basepath = window.location.protocol + '//' + window.location.host,
          relativePath = window.location.href.replace(basepath, '');

      if (relativePath.indexOf('/c/')) {
        var relativePathSplitted = relativePath.split('/c/');
        var categoryUrl = String(relativePathSplitted[0] + '/c/');
        var categoryName = String(relativePathSplitted[1]);

        if (categoryName.indexOf('?')) {
          categoryName = categoryName.split('?')[0];
        }

        if (categoryName.indexOf('#')) {
          categoryName = categoryName.split('#')[0];
        }

        var queryString = $('.ph-querystringvalue').val();
        var sortValue = $('#sortOptions2').val();

        categoryJsonUrl = categoryUrl + 'getProducts.json?categoryCode=' + categoryName + '&page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page';
      }

      return categoryJsonUrl;
    },
    selectJsonURL: function(pageLengths) {
      var jsonUrlSelected = '',
          basepath = window.location.protocol + '//' + window.location.host,
          relativePath = window.location.href.replace(basepath, '');

      var relativePathSplitted = relativePath.split('?')[0];

      if ($('.ph-searchresultpage').length > 0) {
        var queryString = $('.ph-querystringvalue').val();
        var sortValue = $('#sortOptions2').val();

        jsonUrlSelected = basepath + relativePathSplitted + '/getSearchResults.json?page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page';
      } else {
        jsonUrlSelected = ACC.decisionPageInfiniteLoader.categoryPageJsonPath(pageLengths);
      }

      return jsonUrlSelected;
    },
    loadContentSmartly: function(container, observer) {
      var tpages = 'totalpages-available',
          decpageItem = 'decisionpage__item',
          pageLength = $('.ph-decisionpage__cards').find('.ph-' + decpageItem).length / parseInt($('.decisionpage_items_perpage').val(), 10),
          numberOfPages = parseInt($('.ph-itemsshown').attr('data-pagenumber'), 10),
          pageLengths = Math.ceil(pageLength),
          initiated = parseInt($('.' + tpages).attr('data-initiated'), 10),
          notifymeBtn = 'notifyme-button';

      if (initiated < pageLengths) {
        $('.' + tpages).attr('data-initiated', pageLengths);
        $.ajax({
          url: ACC.decisionPageInfiniteLoader.selectJsonURL(pageLengths),
          dataType: 'json',
          async: false,
          success: function(response) {
            response.results.map(ACC.decisionPageInfiniteLoader.processTemplating);
            ACC.decisionPageInfiniteLoader.filterPromotionMsg();

            // Price call changes
            var prodCodes = [];

            prodCodes = ACC.decisionPageInfiniteLoader.loadProductCodeArray(prodCodes, response);

            if ($('.ph-enablepricingcall').length > 0) {
              for (var respid = 0; respid < response.results.length; respid = respid + 1) {
                $('#' + lazyDecisionItemId + response.results[respid].code).find('.' + lazyAddtoCart).addClass('hidden');
                $('#' + lazyDecisionItemId + response.results[respid].code).find('.' + lazyLoadIcon).removeClass('hidden');
              }
            }

            if (prodCodes.length !== 0) {
              ACC.decisionPageInfiniteLoader.loadProductPriceInfinite(prodCodes);
              ACC.decisionPageInfiniteLoader.loadProductQuantity(prodCodes);
            }

            if (prodCodes.length !== 0 && $('.ph-sap-orderBlock').length > 0) {
              $('.' + addtocartButton).addClass(disableButton).attr('disabled', 'disabled');
              $('.ph-cart').addClass(cartDisable);
              $('.ph-' + notifymeBtn).addClass(disableButton);
            }

            $('.ph-ratingAndreview').each(function() {
              if ($(this).attr('data-url') !== '' && $(this).attr('data-url') !== 'null') {
                $(this).css('cursor', 'pointer');
                $(this).on('click', function() {
                  var ratingUrl = $(this).attr('data-url'),
                      ratingNumber = $(this).attr('data-rating');

                  if (ratingNumber > 0) {
                    ACC.common.showRatingsConfirmationPopup(ratingUrl);
                  }
                });
              } else {
                $(this).css('cursor', 'default');
              }
            });
          }
        });
      } else {
        $intObs.hide();
      }

      observer.unobserve(container);

      if (pageLengths >= numberOfPages) {
        $intObs.remove();
        setTimeout(function() {
          ACC.decisionPageInfiniteLoader.isProductCardEmpty();
        }, 200);
      }
    },
    isObserverVisible: function() {
      var isLoading = false;

      if ($('.ph-intersection-observer:visible').length > 0 || $('.ph-instock-loader:visible').length > 0) {
        isLoading = true;
      }

      return isLoading;
    },
    isProductCardEmpty: function() {
      var categoryCode = $(ACC.decisionPageInfiniteLoader.categoryCode).val(),
          showMsg = false,
          deciPage = '#decisionpage',
          decItemVisible = ' .ph-decisionpage__item:visible';

      showMsg = ACC.decisionPageInfiniteLoader.isObserverVisible();

      if ($(deciPage + 'Cards' + decItemVisible).length === 0 && categoryCode !== 'PromotionalCategory' && showMsg === false) {
        $('.ph-productsempty-msg').removeClass('hidden');
      } else {
        $('.ph-productsempty-msg').addClass('hidden');
      }
    },
    customTemplatePolyFill: function(tmpl) {
      var decCards = 'ph-decisionpage__card';

      if (tmpl.querySelector('.' + decCards)) {
        var phDecisionpageCard = tmpl.querySelector('.' + decCards).getAttribute('class');

        tmpl.querySelector('.' + decCards).setAttribute('class', phDecisionpageCard + ' ' + phlazyloadeditem);
      }

      tmpl.querySelector('.ph-product-summaryinfo__wrapper').innerHTML = '';
      tmpl.querySelector('.ph-product-classifications__wrapper').innerHTML = '';

      return tmpl;
    },
    configurationPopupStatus: function($product) {
      var isConfigurationMandatory = false;

      if ($product.productCharacteristics !== null) {
        $product.productCharacteristics.forEach(function(characteristics) {
          if (characteristics.isMandatory === true) {
            isConfigurationMandatory = true;
          }
        });
      }

      return isConfigurationMandatory;
    },
    getTmplNode: function($product) {
      var tmpl = {};

      var decItem = 'ph-decisionpage__item';

      if ('content' in document.createElement('template')) {
        tmpl = document.getElementById('dppTemplate').content.cloneNode(true);
        tmpl.querySelector('.' + decItem).setAttribute('id', 'decisionpageitem' + $product.code);
      } else {
        if (document.getElementById('dppTemplate') && document.getElementById('dppTemplate').querySelector('.' + decItem).cloneNode(true)) {
          tmpl = document.getElementById('dppTemplate').querySelector('.' + decItem).cloneNode(true);
        } else {
          tmpl = document.getElementById('decisionpageCards').querySelector('.' + decItem).cloneNode(true);
        }

        if (window.NodeList && !NodeList.prototype.forEach) {
          NodeList.prototype.forEach = Array.prototype.forEach;
        }

        tmpl = ACC.decisionPageInfiniteLoader.customTemplatePolyFill(tmpl);
        tmpl.setAttribute('id', 'decisionpageitem' + $product.code);

        if (tmpl.querySelector('.' + oStock)) {
          tmpl.querySelector('.' + oStock).setAttribute('class', 'ph-product__outofstock hidden');
        }
      }

      return tmpl;
    },
    loadProductCardAfterAjax: function() {
      var pageType = $('#ph-dec-pageType').val(),
          isNewType = false;

      if (pageType === 'productList' || pageType === 'search') {
        isNewType = true;
      }

      return isNewType;
    },
    /* eslint-disable complexity*/
    processTemplating: function($product) {
      var tmpl = ACC.decisionPageInfiniteLoader.getTmplNode($product),
          enableNewType = false,
          lazyrating = $('.ph-lazyrating').val(),
          txtDisable = 'ph-disable-button',
          notifymeBtn = 'notifyme-button',
          arrayofdchain = 0,
          $productContainer = '',
          dchainvalueContent = '';

      arrayofdchain = ACC.decisionPageInfiniteLoader.checkdchainInList();

      tmpl = ACC.decisionPageInfiniteLoader.productTopContent(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageInfo(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageProdNameSection(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageIndicators(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageClassification(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.decisionPageAddtoCart(tmpl, $product);
      tmpl = ACC.decisionPageInfiniteLoader.showDealAvailability(tmpl, $product);

      if (lazyrating === 'true') {
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageRating(tmpl, $product);
      }

      if ($('#usertype').val() === 'CUSTOMERGROUP') {
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageAtpMsg(tmpl, $product);
        tmpl = ACC.decisionPageInfiniteLoader.decisionPagePrice(tmpl, $product);
        tmpl = ACC.decisionPageInfiniteLoader.decisionPageAddtoCart(tmpl, $product);

        if (tmpl.querySelector('.ph-loader')) {
          tmpl.querySelector('.ph-loader').classList.remove('hidden');
        }
      }

      enableNewType = ACC.decisionPageInfiniteLoader.loadProductCardAfterAjax();

      if ($(ACC.decisionPageInfiniteLoader.inStockChkBox).prop(ACC.decisionPageInfiniteLoader.isChecked) && enableNewType) {
        tmpl.querySelector(ACC.decisionPageInfiniteLoader.decPageItem).classList.add(ACC.decisionPageInfiniteLoader.phdnoneCls);
        tmpl.querySelector(ACC.decisionPageInfiniteLoader.decPageItem).classList.remove(ACC.decisionPageInfiniteLoader.phdflexCls);
        ACC.decisionPageInfiniteLoader.intObs.hide();
        $('.ph-instock-loader').removeClass('hidden');
      }

      $decisionpageCards.append(tmpl);

      $productContainer = $('#decisionpageitem' + $product.code);
      dchainvalueContent = $productContainer.find('.ph-valueDchain').html();

      if (dchainvalueContent !== '') {
        if ($.inArray($product.dchainValue, arrayofdchain) !== -1) {
          $productContainer.find('.ph-lazyDchainInd').removeClass('ph-d-none');
          $productContainer.find('.ph-lazyDchainInd_list').removeClass('ph-d-none');
          $productContainer.find('.ph-dchainvalue' + $product.dchainValue).removeClass('ph-d-none');
          $productContainer.find('.ph-dchainvaluelist' + $product.dchainValue).removeClass('ph-d-none');
        }
      }

      if ($product.validProduct === false) {
        $productContainer.find('.ph-cart').attr('disabled', 'disabled');
        $productContainer.find('.ph-cart').addClass(txtDisable);
        $productContainer.find('.addToCartButton').addClass(txtDisable);
      }

      if ($('.ph-disablebutton').length > 0) {
        $('.ph-cart').attr('disabled', 'disabled');
        $('.ph-cart').addClass(txtDisable);
        $('.addToCartButton').addClass(txtDisable);
        $('.ph-' + notifymeBtn).removeClass('ph-blue-button').addClass(txtDisable);
      }

      var $lazylistviewonly = $('.ph-listview-only');
      var $lazygridviewonly = $('.ph-gridview-only');

      if (localStorage.getItem('viewmode') === 'list') {
        $lazygridviewonly.addClass('hidden');
        $lazylistviewonly.removeClass('hidden');
      } else {
        $lazygridviewonly.removeClass('hidden');
        $lazylistviewonly.addClass('hidden');
      }

      if ($(document).find('.ph-add2cart-formload').length > 0) {
        $(document).find('.ph-add2cart-formload').removeClass('ph-add2cart-formload');
      }

      ACC.decisionPageInfiniteLoader.loadAvailabilitycheck($product.code, $product.url);
    },
    /* eslint-enable complexity*/
    productTopContent: function(tmpl, $product) {
      var productAnchorDomItem = tmpl.querySelector('.ph-decision-page__topcontent > a');

      productAnchorDomItem.setAttribute('data-productimg', $product.code);
      productAnchorDomItem.setAttribute('href', ACC.config.encodedContextPath + $product.url);
      productAnchorDomItem.setAttribute('title', $product.name);

      tmpl.querySelector('.ph-produrl--list').setAttribute('href', ACC.config.encodedContextPath + $product.url);
      tmpl.querySelector('.ph-produrl--list').setAttribute('title', $product.name);

      var imageUrl = '/philipsb2bstorefront/_ui/desktop/theme-green/images/default-product-img.svg';


      if (String($product.imageURL) !== 'null' && String($product.imageURL) !== '') {
        imageUrl = $product.imageURL + '&wid=140&hei=140&$jpgsmall$';
      }

      var imageContainerDomItems = tmpl.querySelectorAll('.ph-decisionpage__image img');

      imageContainerDomItems.forEach(function(imageContainerDomItem) {
        imageContainerDomItem.setAttribute('src', imageUrl);
        imageContainerDomItem.setAttribute('alt', $product.name);
      });

      return tmpl;
    },
    googleAnalytics: function(tmpl, $product) {
      var $isCategoryPage = $('.template-pages-category-productListPage').length,
          $isSearchPage = $('.page-search').length,
          listName = '',
          currentIndex = parseInt($('.current_index_plp').text(), 10),
          decisonPageCardClass = '.ph-decisionpage__card';

      currentIndex = currentIndex + 1;
      $('.current_index_plp').text(String(currentIndex));

      if ($isCategoryPage > 0) {
        listName = $('.ph-headerparent__categorycode').val();
      } else if ($isSearchPage > 0) {
        listName = 'search-results';
      }

      tmpl.querySelector(decisonPageCardClass).setAttribute('data-ctn', $product.ctv);
      tmpl.querySelector(decisonPageCardClass).setAttribute('data-list-name', listName);
      tmpl.querySelector(decisonPageCardClass).setAttribute('data-list-position', currentIndex);
    },
    decisionPageInfo: function(tmpl, $product) {
      var prdtId = $('.ph-preferredProductId').val(),
          emptyTxt = $('.ph-notAvailTxt').val(),
          productCode = '';

      if (prdtId === 'PRODUCT_EAN') {
        productCode = $product.sapEan;
      } else {
        productCode = $product.code;
      }

      if (productCode.length === 0) {
        productCode = emptyTxt;
      }

      if (String(productCode) !== 'null' && String(productCode) !== '' && String(productCode) !== String($product.ctn)) {
        tmpl.querySelector('.ph-code').innerHTML = ':&nbsp;' + productCode;
        tmpl.querySelector('.ph-code--list').innerHTML = ':&nbsp;' + productCode;
        tmpl.querySelector('.ph-code-gridmb').innerHTML = productCode;
        tmpl.querySelector('.ph-code-listmb').innerHTML = productCode;
        tmpl.querySelector('.ph-prvalue').classList.remove('hidden');
        tmpl.querySelector('.ph-prvalue--list').classList.remove('hidden');
      }

      if (String($product.ctv) !== 'null' && String($product.ctv) !== '') {
        tmpl.querySelector('.ph-eanvalue').innerHTML = ':&nbsp;' + $product.ctv;
        tmpl.querySelector('.ph-eanvalue--list').innerHTML = ':&nbsp;' + $product.ctv;
        tmpl.querySelector('.ph-eanvalue-gridmb').innerHTML = $product.ctv;
        tmpl.querySelector('.ph-eanvalue-listmb').innerHTML = $product.ctv;
        tmpl.querySelector('.ph-eanlabel').classList.remove('hidden');
        tmpl.querySelector('.ph-eanlabel--list').classList.remove('hidden');
      }

      ACC.decisionPageInfiniteLoader.googleAnalytics(tmpl, $product);

      return tmpl;
    },
    decisionPageProdNameSection: function(tmpl, $product) {
      tmpl.querySelector('.ph-product-withdesc').innerHTML = $product.displayName;
      tmpl.querySelector('.ph-plp_familyName').innerHTML = $product.familyName;
      tmpl.querySelector('.ph-plp_descriptor').innerHTML = $product.descriptor;

      if (!$product.descriptor && $product.name) {
        var plpsapName = $product.name.replace($product.ctv, '');

        tmpl.querySelector('.ph-plp_sapName').innerHTML = plpsapName;
      }

      return tmpl;
    },
    checkdchainInList: function() {
      var dchainlistvalue = $('.ph-dChainValuesList').html(),
          dchainlistvalueArray = 0;

      dchainlistvalue = dchainlistvalue.replace('[', '');
      dchainlistvalue = dchainlistvalue.replace(']', '');
      dchainlistvalue = dchainlistvalue.replace(/ /g, '');
      dchainlistvalueArray = dchainlistvalue.split(',');

      return dchainlistvalueArray;
    },
    decisionPageIndicators: function(tmpl, $product) {
      var qtyUnits = $product.numberContentUnits,
          showpacksize = $('.ph-showpackagesize').val();

      tmpl.querySelector('.ph-decisionpage__info').setAttribute('data-prodid', $product.code);
      tmpl.querySelector('.ph-pkgqty').innerHTML = $product.numberContentUnits + ' ';
      tmpl.querySelector('.ph-pkgunit').innerHTML = $product.unit;

      /* eslint-disable radix */
      if (parseInt(qtyUnits) > 0 && showpacksize === 'true') {
        tmpl.querySelector('.ph-packageCount').classList.remove('hidden');
      }
      /* eslint-enable radix */

      if ($product.newProductFlag === true) {
        tmpl.querySelector('.ph-lazyNewInd').classList.remove('ph-d-none');
        tmpl.querySelector('.ph-lazyNewInd--list').classList.remove('ph-d-none');
      }

      return tmpl;
    },
    decisionPageClassification: function(tmpl, $product) {
      var classificationData = '';

      if (String($product.classifications) !== 'undefined' && String($product.classifications) !== 'null' && String($product.classifications) !== '') {
        classificationData = classificationData + '<ul class="product-classification">';
        $product.classifications.forEach(function(classification) {
          var subClassificationData = ACC.decisionPageInfiniteLoader.subClassification(classification);

          classificationData = classificationData + '<li><strong>' + classification.name + '</strong>' + subClassificationData + '</li>';
        });

        classificationData = classificationData + '</ul>';
      }

      tmpl.querySelector('.ph-product-classifications__wrapper').innerHTML = classificationData;

      return tmpl;
    },
    decisionPageRating: function(tmpl, $product) {
      var ratingAndreview = '.ph-ratingAndreview',
          ratingClass = tmpl.querySelectorAll(ratingAndreview);

      tmpl.querySelector('.p-rating-display-inner').setAttribute('data-rate-value', parseFloat($product.ratingInPercentage).toFixed(3));
      tmpl.querySelector('.p-rating-display-inner').setAttribute('style', 'width:' + Math.round($product.ratingInPercentage) + '%');

      for (var inx = 0; inx < ratingClass.length; inx = inx + 1) {
        ratingClass[inx].setAttribute('data-url', $product.consumerSiteProductLink);
        ratingClass[inx].setAttribute('data-rating', $product.totalReviewCount);
      }

      if ($product.totalReviewCount > 0) {
        tmpl.querySelector('.p-total-review-count').innerHTML = '(' + $product.totalReviewCount + ')';
        tmpl.querySelector(ratingAndreview).setAttribute('style', 'cursor:pointer');
      }

      if ($product.averageOverallRating > 0) {
        tmpl.querySelector('.ph-rating-gray').innerHTML = parseFloat($product.averageOverallRating).toFixed(1) + '/5';
        tmpl.querySelector('.ph-overallRate').innerHTML = parseFloat($product.averageOverallRating);
      }

      return tmpl;
    },
    subClassification: function(classification) {
      var subClassificationData = '';

      if (String(classification.features) !== 'undefined' && String(classification.features) !== 'null' && String(classification.features) !== '') {
        subClassificationData = subClassificationData + '<ul class="product-classification">';
        classification.features.forEach(function(feature) {
          var featureData = ACC.decisionPageInfiniteLoader.features(feature);

          subClassificationData = subClassificationData + '<li><strong>' + feature.name + '</strong>' + featureData + '</li>';
        });
        subClassificationData = subClassificationData + '</ul>';
      }

      return subClassificationData;
    },
    features: function(feature) {
      var featureData = '';

      if (String(feature.featureValues) !== 'undefined' && String(feature.featureValues) !== 'null' && String(feature.featureValues) !== '') {
        featureData = featureData + '<span>';
        feature.featureValues.forEach(function(featureValue) {
          if (featureValue.value !== 'undefined') {
            featureData = featureData + '<span>' + featureValue.value + '&nbsp;</span>';
          }

          if (featureValue.featureUnit !== 'undefined' && featureValue.featureUnit.symbol !== 'undefined') {
            featureData = featureData + '<span>' + feature.featureUnit.symbol + '&nbsp;</span>';
          }
        });
        featureData = featureData + '</span>';
      }

      return featureData;
    },
    decisionPageAtpMsg: function(tmpl, $product) {
      var atpmsgdiv = '';
      var atpData = $product.philipsATPData;

      if (String(atpData) !== 'null' && (typeof atpData.isError !== 'undefined' && String(atpData.isError) === 'true')) {
        var atpvaratpmsg = String($('.ph-atpvar-atpmsg').text());

        if (atpvaratpmsg.trim() !== 'null') {
          atpmsgdiv = '<p class="ph-atpmessage strong ">' + atpvaratpmsg + '</p>';
        }
      } else if (String($product.hazardousCode) === String($('.ph-atpvar-atpHzCode').text()) && (String(atpData) !== 'null' && String(atpData.isProductInStock === 'true'))) {
        atpmsgdiv = '<p class="ph-atpmessage strong">' + $('.ph-atpvar-atpHdzTextInstockMsg').html() + '</p>';
      } else {
        var productAtpIdentifier = '';

        if (String($product.atpIdentifier) !== 'null' && String($product.atpIdentifier) !== '') {
          productAtpIdentifier = $product.atpIdentifier;
        }

        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditions($product, atpData, productAtpIdentifier);
      }

      tmpl.querySelector('.ph-atpmsgdiv').innerHTML = atpmsgdiv;

      return tmpl;
    },
    atpConditions: function($product, atpData, productAtpIdentifier) {
      var atpmsgdiv = '';

      if (productAtpIdentifier !== '' && String(atpData) !== 'null' && String(atpData.isProductInStock) === 'true') {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsIdentifier($product);
      } else if (productAtpIdentifier === '' && ($product.leadTime !== null && $product.leadTime > 0)) {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsNoIdentifier($product);
      } else if (String(atpData) !== 'null' && String(atpData.isProductInStock) !== 'true') {
        atpmsgdiv = ACC.decisionPageInfiniteLoader.atpConditionsProductNotInStock();
      } else {
        var atpvaratpmsg = String($('.ph-atpvar-atpmsg').text());

        if (atpvaratpmsg.trim() !== 'null') {
          atpmsgdiv = '<p class="ph-atpmessage strong ">' + atpvaratpmsg + '</p>';
        }
      }

      return atpmsgdiv;
    },
    atpConditionsIdentifier: function($product) {
      var deliveryDateValue = '';
      var instockDeliveryRange = String($('.ph-atpvar-instockDeliveryRange').text());

      if ($product.philipsATPData && $product.philipsATPData.estimateDeliveryDate && $product.philipsATPData.estimateDeliveryDate !== '') {
        deliveryDateValue = $product.philipsATPData.estimateDeliveryDate;
      }

      return '<p class="ph-atpmessage strong ph-atpidentifier">' + instockDeliveryRange + ' ' + deliveryDateValue + '</p>';
    },
    atpConditionsNoIdentifier: function($product) {
      var atpvarAtpleadTime = String($('.ph-atpvar-atpleadTime').html());

      if (atpvarAtpleadTime.indexOf('{0}')) {
        atpvarAtpleadTime = atpvarAtpleadTime.replace('{0}', $product.leadTime);
      }

      return '<p class="ph-atpmessage strong ph-atpleadtime">' + atpvarAtpleadTime + '</p>';
    },
    atpConditionsProductNotInStock: function() {
      var atpmsgdiv = '<p class="ph-atpmessage strong">' +
       $('.ph-atpvar-outofstockmsg').text() +
       '</p>';

      if ($('.ph-atpvar-page2').text() === 'CHECKOUT') {
        atpmsgdiv = '<p class="ph-atpmessage strong ph-atpincheckout">' +
         $('.ph-atpvar-checkoutOutofstockMessage').text() +
         '</p>';
      } else if ($('.ph-atpvar-page1').text() === 'CART') {
        atpmsgdiv = '<p class="ph-atpmessage strong ph-atpincart">' +
         $('.ph-atpvar-cartoutofstockmsg').text() +
         '</p>';
      }

      return atpmsgdiv;
    },
    decisionPagePrice: function(tmpl, $product) {
      if (String($product.volumePricesFlag) === 'true') {
        tmpl.querySelector('.volumePricesFlag').classList.remove('hidden');
      }

      return tmpl;
    },

    decisionPageAddtoCart: function(tmpl, $product) {
      var addtocartform = '.ph-addtocartform';
      var addToCartButton = '.addToCartButton';
      var notifymeLazy = '.ph-notifymeLazy',
          productEan = $product.sapEan,
          emptytxt = $('.ph-notAvailTxt').val();

      if (productEan.length === 0) {
        productEan = emptytxt;
      }

      if ($product.isZoomDelivered !== true) {
        $product.isZoomDelivered = false;
      }

      if (tmpl.querySelector(addtocartform)) {
        tmpl.querySelector(addtocartform).setAttribute('id', 'addToCartForm' + $product.code);
        tmpl.querySelector(notifymeLazy).setAttribute('data-id', $product.code);
        tmpl.querySelector('.' + ACC.common.pdpQuantityCls).setAttribute('data-prdcode', $product.code);
        tmpl.querySelector('.productCodePost').setAttribute('value', $product.code);
        tmpl.querySelector(addToCartButton).setAttribute('value', $product.code);
        tmpl.querySelector(addToCartButton).setAttribute('data-ctv', $product.ctv);
        tmpl.querySelector(addToCartButton).setAttribute('data-ean', productEan);
        tmpl.querySelector(addToCartButton).setAttribute('iszoomdelivered', $product.isZoomDelivered);
        tmpl.querySelector(addToCartButton).classList.add('ph-blocked-' + $product.code);
        tmpl.querySelector('.ph-notifyblock').classList.add('ph-blknotify-' + $product.code);
      }

      if (tmpl.querySelector(addtocartform) && $product.isZoomDelivered === true) {
        tmpl.querySelector('.plp_qtyinput').readOnly = true;
      }

      return tmpl;
    },
    renderAddtocartButton: function(result, $othis, havePrice, isConfigurationMandatory) {
      if (isConfigurationMandatory && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock') {
        $othis.find('.ph-' + phLoaderClass).addClass('hidden');
        $othis.find('.' + decisionpageconfigbutton).removeClass('hidden');

        if (result.code !== null) {
          $othis.find('.' + decisionpageconfigbutton).attr('data-productcode', result.code);
        }
      } else {
        $othis.find('.ph-' + phLoaderClass).addClass('hidden');
        $othis.find('.' + addtocartButton).removeClass('hidden');

        if (havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved') {
          $othis.find('.' + addtocartButton).attr('disabled', false);
          $othis.find('.' + addtocartButton).removeClass('out-of-stock ph-disabledbutton');
          $othis.find('.' + addtocartButton).prop('type', 'submit');
          $othis.find('.' + addtocartButton).attr('aria-disabled', false);
        } else {
          $othis.find('.' + oStock).removeClass('hidden');
        }
      }
    },
    renderAddtocartButtonHhs: function(result, element, havePrice, isConfigurationMandatory) {
      if (isConfigurationMandatory && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock') {
        $(element).find('.ph-' + phLoaderClass).addClass('hidden');
        $(element).find('.' + decisionpageconfigbutton).removeClass('hidden');
        $(element).find('.' + decisionpageconfigbutton).attr('data-productcode', result.code);
      } else {
        $(element).find('.ph-' + phLoaderClass).addClass('hidden');
        $(element).find('.' + addtocartButton).removeClass('hidden');

        if (havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved') {
          $(element).find('.' + addtocartButton).attr('disabled', false);
          $(element).find('.' + addtocartButton).prop('type', 'submit');
          $(element).find('.' + addtocartButton).attr('aria-disabled', false);
        } else {
          $(element).find('.' + oStock).removeClass('hidden');
        }
      }
    },
    rrpPriceCallInf: function(result, indx) {
      var product = result[indx];
      var prodPriceList = result[indx].priceList;

      if (prodPriceList.length > 0) {
        for (var priceIndx = 0; priceIndx < prodPriceList.length; priceIndx = priceIndx + 1) {
          var rowPrice = prodPriceList[priceIndx];

          if (rowPrice.pricingConditionCode === 'YLRR' && rowPrice.formattedValue !== null) {
            $('#' + lazyDecisionItemId + product.code).find('.ph-recommend-price').html(rowPrice.formattedValue);
          } else if (rowPrice.pricingConditionCode === 'YLRR' && rowPrice.formattedValue === null) {
            $('#' + lazyDecisionItemId + product.code).find('.ph-dec-inf-rrpsection').addClass('hidden');
          }
        }
      }
    },
    rrpPriceCallDec: function(result, index) {
      var product = result[index];
      var priceList = result[index].priceList;
      var prodRow = '#ph-pl-row-';

      if (priceList.length > 0) {
        for (var priceIndex = 0; priceIndex < priceList.length; priceIndex = priceIndex + 1) {
          var priceRow = priceList[priceIndex];

          if (priceRow.pricingConditionCode === 'YLRR' && priceRow.formattedValue !== null) {
            $(prodRow + product.code).find('.ph-recommend-price').html(priceRow.formattedValue);
          } else if (priceRow.pricingConditionCode === 'YLRR' && priceRow.formattedValue === null) {
            $(prodRow + product.code).find('.ph-dec-rrpsection').addClass('hidden');
          }
        }
      }
    },
    /* eslint-disable complexity */
    loadPriceConditioncheck: function(result, indx) {
      var product = result[indx],
          prodPriceList = result[indx].priceList,
          $isPromotionEnabled = $('.ph-promotionenabled'),
          discVal = result[indx].discountPromotion,
          freePriceText = $('.ph-freePriceText').val();

      if (prodPriceList.length > 0) {
        var pricesText = '',
            addStrikeClass = '',
            ribbonText = $('#' + lazyDecisionItemId + product.code).find('.ph-discount-ribbon__text').html();

        for (var priceIndx = 0; priceIndx < prodPriceList.length; priceIndx = priceIndx + 1) {
          var rowPrice = prodPriceList[priceIndx];

          addStrikeClass = '';

          if (rowPrice.priceType === 'FROM' && $isPromotionEnabled.length > 0) {
            addStrikeClass = 'ph-strikeprice';

            var discRibbon = $('#' + lazyDecisionItemId + product.code).find('.ph-discount-ribbon__text');

            discRibbon.html(ribbonText.replace('0', discVal));

            $('#' + lazyDecisionItemId + product.code).find('.ph-lazyPromoInd').removeClass('ph-d-none');
            $('#' + lazyDecisionItemId + product.code).find('.ph-lazyPromoInd--list').removeClass('ph-d-none');
            pricesText = pricesText + ('<span class="ph-prodprice ' + addStrikeClass + '">' + rowPrice.formattedValue + '</span>');
          } else if (rowPrice.priceType === 'BUY' && rowPrice.pricingConditionCode !== 'YLRR' && rowPrice.value !== 0.0) {
            pricesText = pricesText + ('<span class="ph-prodprice ph-prodprice-pop ' + addStrikeClass + '">' + rowPrice.formattedValue + '</span>');
          } else if (product.isFreeMarketingProduct === true && rowPrice.pricingConditionCode === 'PNTP' && rowPrice.value === 0.0) {
            pricesText = pricesText + ('<span class="ph-prodprice ph-prodprice-pop ' + addStrikeClass + '">' + freePriceText + '</span>');
          }

          if (rowPrice.iconType === 'red') {
            $('#' + lazyDecisionItemId + product.code).find('.ph-promotionicon__red').removeClass('ph-hide__icons');
            $('#' + lazyDecisionItemId + product.code).find('.ph-promotionenddate').html(rowPrice.promotionEndDate);
          } else if (rowPrice.iconType === 'blue') {
            $('#' + lazyDecisionItemId + product.code).find('.ph-promotionicon__blue').removeClass('ph-hide__icons');
            $('#' + lazyDecisionItemId + product.code).find('.ph-pricedate').html(rowPrice.promotionEndDate);
          }

          ACC.decisionPageInfiniteLoader.rrpPriceCallInf(result, indx);
        }

        $('#' + lazyDecisionItemId + product.code).find('.ph-prices-section').html(pricesText);
      }
    },
    /* eslint-enable complexity */
    getPriceData: function(prodCodes, successCallback, failureCallback) {
      if (prodCodes) {
        $.ajax({
          url: ACC.config.encodedContextPath + '/asyncproduct/getpricedata',
          type: 'POST',
          datatype: 'json',
          data: {
            codes: prodCodes.toString()
          },
          success: function(data) {
            successCallback(data);
          },
          error: function(error) {
            if (failureCallback) {
              failureCallback(error);
            }
          }
        });
      }
    },
    showAnnualPopup: function(prodCode) {
      $('#' + lazyDecisionItemId + prodCode).find('.ph-cartbtn-wrapper').on('mouseenter', function() {
        $('#' + lazyDecisionItemId + prodCode).find('.ph-addToCart_AnnualPopupMsg').removeClass('hidden');
        $('#' + lazyDecisionItemId + prodCode).siblings('.ph-cartbtn-wrapper').find('.ph-cart').addClass('ph-outofstockdisablebtn');
      });
      $('#' + lazyDecisionItemId + prodCode).find('.ph-cartbtn-wrapper').on('mouseleave', function() {
        $('#' + lazyDecisionItemId + prodCode).find('.ph-addToCart_AnnualPopupMsg').addClass('hidden');
      });
    },
    loadProdQuantityCheck: function(result) {
      if (Array.isArray(result.productMaxQtyDatas) && result.productMaxQtyDatas.length > 0) {
        for (var index = 0; index < result.productMaxQtyDatas.length; index = index + 1) {
          var product = result.productMaxQtyDatas[index],
              currentItem = $('#' + lazyDecisionItemId + product.productCode);

          if (product.showError === true || product.maxQtyToOrder === 0) {
            ACC.decisionPageInfiniteLoader.showAnnualPopup(product.productCode);
            currentItem.find('.ph-cartbtn-wrapper').find('.ph-cart').addClass('ph-outofstockdisablebtn');
            currentItem.find('.ph-addToCartButton').addClass('ph-outofstockdisablebtn').attr('disabled', 'disabled');
          }


          currentItem.find('#ph-item_maxQuantity_value').html(product.maxQtyToOrder);
          currentItem.find('#ph-item_orderedQuantity_value').html(product.totalOrdered);

          currentItem.find('.ph-productMaxQty_totalOrdered').removeClass('hidden');
        }
      }
    },
    loadProductQuantity: function(prodCodes) {
      var maxQtyEnabled = $('#maxQuantityToggle').val();

      if (prodCodes && maxQtyEnabled === 'true') {
        $.ajax({
          url: ACC.config.encodedContextPath + '/asyncproduct/getmaxquantity',
          type: 'POST',
          datatype: 'json',
          data: {
            codes: prodCodes.toString()
          },
          success: function(result) {
            ACC.decisionPageInfiniteLoader.loadProdQuantityCheck(result);
          }
        });
      }
    },
    loadProductPriceInfinite: function(prodCodes) {
      ACC.decisionPageInfiniteLoader.getPriceData(prodCodes, function(resultList) {
        if (Array.isArray(resultList) && resultList.length > 0) {
          for (var indx = 0; indx < resultList.length; indx = indx + 1) {
            ACC.decisionPageInfiniteLoader.loadPriceConditioncheck(resultList, indx);

            if ($('.ph-enablepricingcall').length > 0) {
              $('#' + lazyDecisionItemId + resultList[indx].code).find('.' + lazyAddtoCart).removeClass('hidden');
              $('#' + lazyDecisionItemId + resultList[indx].code).find('.' + lazyLoadIcon).addClass('hidden');
            }
          }
        }
      });
    },
    loadProductCodeArray: function(prodCodes, response) {
      for (var priceIndx = 0; priceIndx < response.results.length; priceIndx = priceIndx + 1) {
        prodCodes.push(response.results[priceIndx].code);
      }

      return prodCodes;
    },
    loadPricePromotioncheck: function(result, indx) {
      var product = result[indx],
          prodPriceList = result[indx].priceList,
          $isPromotionEnabled = $('.ph-promotionenabled'),
          stringPageItem = 'pageitem',
          $prodRow = $('#decision' + stringPageItem + product.code);

      if (prodPriceList.length > 0) {
        for (var priceIndx = 0; priceIndx < prodPriceList.length; priceIndx = priceIndx + 1) {
          var rowPrice = prodPriceList[priceIndx],
              txtNotPromo = 'notpromo';

          // Promotion setup
          if (rowPrice.pricingConditionCode === 'YDNC' && $isPromotionEnabled.length > 0) {
            $prodRow.addClass('ph-filter-promo');
            $prodRow.removeClass('ph-filter-' + txtNotPromo);
            $prodRow.css('visibility', 'visible');
          }
        }
      }
    },
    getLastPartOfUrl: function($url) {
      var url = $url;
      var urlsplitque = url.split('?');
      var urlsplit = urlsplitque[0].split('/');
      var lastpart = urlsplit[urlsplit.length - 1];

      if (lastpart === '') {
        lastpart = urlsplit[urlsplit.length - 2];
      }

      return lastpart;
    },
    lazyhecknobackorderstock: function(nobackorderprod, prodcode, outofstockdisablebtn, outStockContent) {
      if (nobackorderprod === 'true') {
        prodcode.find('.' + lazyAddtoCart).attr('disabled', 'disabled');
        prodcode.find('.ph' + outStockContent).addClass(outofstockdisablebtn);
      }
    },
    bindKeyUpEvt: function(availOrange, isBackorder, availGreen, maxQtyEnabled) {
      var bindEvent = false,
          prdWithStkCheck = $('#ph-filter-Availability').prop('checked'),
          isValid = availOrange || availGreen || prdWithStkCheck;

      if (isValid && (isBackorder === 'true' || maxQtyEnabled === 'true')) {
        bindEvent = true;
      }

      return bindEvent;
    },
    showMaxQuantityPopup: function(currentItem, btnWrapStr, outofstockdisablebtn) {
      $(currentItem).siblings('.ph-productQuantity_popupMsg').removeClass('hidden');
      $(currentItem).siblings('.' + btnWrapStr).find('.' + lazyAddtoCart).attr('disabled', 'disabled');
      $(currentItem).siblings('.' + btnWrapStr).find('.ph-cart').addClass(outofstockdisablebtn);
    },
    showLowStockPopup: function(currentItem, btnWrapStr, outofstockdisablebtn) {
      $(currentItem).siblings('.ph-productLowStock_popupMsg').removeClass('hidden');
      $(currentItem).siblings('.' + btnWrapStr).find('.' + lazyAddtoCart).attr('disabled', 'disabled');
      $(currentItem).siblings('.' + btnWrapStr).find('.ph-cart').addClass(outofstockdisablebtn);
    },
    hideMaxQuantityPopup: function(currentItem, btnWrapStr, outofstockdisablebtn) {
      $(currentItem).siblings('.ph-productQuantity_popupMsg').addClass('hidden');
      $(currentItem).siblings('.' + btnWrapStr).find('.' + lazyAddtoCart).removeAttr('disabled');
      $(currentItem).siblings('.' + btnWrapStr).find('.ph-cart').removeClass(outofstockdisablebtn);
    },
    hideLowStockPopup: function(currentItem, btnWrapStr, outofstockdisablebtn) {
      $(currentItem).siblings('.ph-productLowStock_popupMsg').addClass('hidden');
      $(currentItem).siblings('.' + btnWrapStr).find('.' + lazyAddtoCart).removeAttr('disabled');
      $(currentItem).siblings('.' + btnWrapStr).find('.ph-cart').removeClass(outofstockdisablebtn);
    },
    hideMaxQtyAndLowStockPopup: function(currentItem, btnWrapStr, outofstockdisablebtn) {
      ACC.decisionPageInfiniteLoader.hideMaxQuantityPopup(currentItem, btnWrapStr, outofstockdisablebtn);

      ACC.decisionPageInfiniteLoader.hideLowStockPopup(currentItem, btnWrapStr, outofstockdisablebtn);
    },
    evaluatePopupMsg: function(msgQty, popupEl) {
      var popupText = popupEl.html();

      if (popupText.indexOf('{0}') >= 0) {
        popupEl.html(popupEl.html().replace('{0}', msgQty));
      } else {
        var digits = popupText.match(/\d+/g);

        popupEl.html(popupEl.html().replace(digits, msgQty));
      }
    },
    /* eslint-disable complexity*/
    lazycheckquantitystock: function(mxStockprod, nobackorderprod, outofstockdisablebtn, prodcode) {
      var isBindEvent = false;

      $(prodcode).each(function() {
        isBindEvent = ACC.decisionPageInfiniteLoader.bindKeyUpEvt($(this).find('.ph-avail-orange').is(':visible'), nobackorderprod, $(this).find('.ph-avail-green').is(':visible'), $('#maxQuantityToggle').val());


        if (isBindEvent === true) {
          $(this).find('.' + ACC.common.pdpQuantityCls).keyup(function() {
            var productQty = parseInt($(this).val(), 10),
                productCode = $(this).attr('data-prdcode'),
                isBlocked = '',
                btnWrapStr = 'ph-cartbtn-wrapper',
                maxQty = 0,
                totalOrdered = 0,
                maxQtyEnabled = $('#maxQuantityToggle').val(),
                lowStockQuantity = parseInt($('#' + lazyDecisionItemId + productCode).find('.ph-availCount:eq(0)').text(), 10);

            if ($('#maxQuantityToggle').val() === 'true') {
              maxQty = parseInt($('#' + lazyDecisionItemId + productCode).find('#ph-item_maxQuantity_value').text(), 10);
              totalOrdered = parseInt($('#' + lazyDecisionItemId + productCode).find('#ph-item_orderedQuantity_value').text(), 10);
            }

            isBlocked = ACC.common.isBlockedProduct(productCode);

            if (!isBlocked) {
              if (maxQty !== totalOrdered) {
                var popupEl = $('#addToCartForm' + productCode).find('.ph-productQuantity_popupMsg');

                if (nobackorderprod === 'true' && maxQtyEnabled === 'true' && maxQty !== 0) {
                  ACC.decisionPageInfiniteLoader.hideMaxQtyAndLowStockPopup(this, btnWrapStr, outofstockdisablebtn);
                  /* eslint-disable  sonarjs/no-duplicated-branches */

                  if (lowStockQuantity === 0 && productQty > (maxQty - totalOrdered)) {
                    ACC.decisionPageInfiniteLoader.showMaxQuantityPopup(this, btnWrapStr, outofstockdisablebtn);
                    ACC.decisionPageInfiniteLoader.evaluatePopupMsg(maxQty - totalOrdered, popupEl);
                  } else if (lowStockQuantity > (maxQty - totalOrdered) && productQty > (maxQty - totalOrdered)) {
                    ACC.decisionPageInfiniteLoader.showMaxQuantityPopup(this, btnWrapStr, outofstockdisablebtn);
                    ACC.decisionPageInfiniteLoader.evaluatePopupMsg(maxQty - totalOrdered, popupEl);
                  } else if (lowStockQuantity !== 0 && lowStockQuantity < maxQty && productQty > lowStockQuantity) {
                    ACC.decisionPageInfiniteLoader.showLowStockPopup(this, btnWrapStr, outofstockdisablebtn);
                    ACC.decisionPageInfiniteLoader.evaluatePopupMsg(lowStockQuantity, popupEl);
                  }
                  /* eslint-enable  sonarjs/no-duplicated-branches */
                } else if (nobackorderprod === 'false' && maxQtyEnabled === 'true' && maxQty !== 0) {
                  ACC.decisionPageInfiniteLoader.hideMaxQtyAndLowStockPopup(this, btnWrapStr, outofstockdisablebtn);

                  if (productQty > (maxQty - totalOrdered)) {
                    ACC.decisionPageInfiniteLoader.evaluatePopupMsg(maxQty - totalOrdered, popupEl);
                    ACC.decisionPageInfiniteLoader.showMaxQuantityPopup(this, btnWrapStr, outofstockdisablebtn);
                  }
                } else if (nobackorderprod === 'true' && maxQtyEnabled === 'false') {
                  ACC.decisionPageInfiniteLoader.hideMaxQtyAndLowStockPopup(this, btnWrapStr, outofstockdisablebtn);

                  if (lowStockQuantity !== 0) {
                    if (productQty > lowStockQuantity) {
                      ACC.decisionPageInfiniteLoader.showLowStockPopup(this, btnWrapStr, outofstockdisablebtn);
                    }
                  } else if (productQty > mxStockprod && lowStockQuantity === 0) {
                    ACC.decisionPageInfiniteLoader.showLowStockPopup(this, btnWrapStr, outofstockdisablebtn);
                  }
                }
              }
            }
          });
        }
      });
    },
    /* eslint-enable complexity*/
    filterAvailability: function($prodRow) {
      var displayFlex = 'ph-d-flex',
          displayNone = 'ph-d-none',
          filteravail = 'filter-Availability';

      if ($('#ph-' + filteravail).prop('checked') === true) {
        $prodRow.removeClass(displayFlex).addClass(displayNone);
      } else {
        $prodRow.addClass(displayFlex).removeClass(displayNone);
      }
    },
    filterAvailabilityEnableDisable: function() {
      var parentDivDec = 'isionpageCards',
          displayFlex = 'ph-d-flex',
          displayNone = 'ph-d-none',
          filterRed = 'ph-filter-red',
          basepathav = window.location.protocol + '//' + window.location.host,
          relativePathav = window.location.href.replace(basepathav, ''),
          promoCheckav = ACC.decisionPageInfiniteLoader.getLastPartOfUrl(relativePathav),
          filterNotPromo = 'ph-filter-notpromo',
          filterAvString = '#ph-filter-';

      if ($(filterAvString + 'Availability').prop(ACC.decisionPageInfiniteLoader.isChecked) === true) {
        $('.ph-searchcount-text').addClass('hidden');
        $('#dec' + parentDivDec).find('.' + filterRed).removeClass(displayFlex).addClass(displayNone);
        ACC.decisionPageInfiniteLoader.isProductCardEmpty();
      } else {
        $('.ph-searchcount-text').removeClass('hidden');
        $('#dec' + parentDivDec).find('.' + filterRed).addClass(displayFlex).removeClass(displayNone);
        ACC.decisionPageInfiniteLoader.isProductCardEmpty();
      }

      if (promoCheckav === 'PromotionalCategory') {
        $('#dec' + parentDivDec).find('.' + filterNotPromo + '.' + filterRed).removeClass(displayFlex).addClass(displayNone);
      }
    },
    filterPromotionMsg: function() {
      var basepath = window.location.protocol + '//' + window.location.host,
          relativePath = window.location.href.replace(basepath, ''),
          promoCheck = ACC.decisionPageInfiniteLoader.getLastPartOfUrl(relativePath),
          promoString = 'PromotionalCategory',
          decisionpageCardsMain = '#decision',
          decisionItem = ' .ph-decisionpage__item';

      if (promoCheck === promoString && $(decisionpageCardsMain + 'pageCards' + decisionItem).length === 0) {
        $('.ph-promotions-msg').removeClass('hidden');
        $('.ph-filter-wrapper').addClass('hide-element');
        $('.ph-decison-pagination-wrapper').css('display', 'none');
      } else if (promoCheck === promoString && $(decisionpageCardsMain + 'pageCards' + decisionItem).length !== 0) {
        $('.ph-promotions-msg').addClass('hidden');
        $('.ph-filter-wrapper').removeClass('hide-element');
        $('.ph-decison-pagination-wrapper').css('display', 'flex');
      }
    },
    filterPromotionCall: function() {
      var basepath = window.location.protocol + '//' + window.location.host,
          relativePath = window.location.href.replace(basepath, ''),
          promoCheck = ACC.decisionPageInfiniteLoader.getLastPartOfUrl(relativePath);

      if (promoCheck === 'PromotionalCategory') {
        $('.ph-filter-notpromo').css('visibility', 'hidden');
        setTimeout(function() {
          ACC.decisionPageInfiniteLoader.filterPromotion();
        }, 3000);
      }
    },
    filterPromotion: function() {
      var parentDiv = 'Cards',
          displayFlex = 'ph-d-flex',
          displayNone = 'ph-d-none',
          filterPromo = 'ph-filter-promo',
          filterNotPromo = 'ph-filter-notpromo',
          txtDecPage = '#decisionpage' + parentDiv;

      $(txtDecPage).find('.' + filterPromo).addClass(displayFlex).removeClass(displayNone);
      $(txtDecPage).find('.' + filterNotPromo).removeClass(displayFlex).addClass(displayNone);
      ACC.decisionPageInfiniteLoader.filterAvailabilityEnableDisable();
      $(txtDecPage).find('.' + filterNotPromo + '.ph-filter-red').removeClass(displayFlex).addClass(displayNone);
    },
    loadPopPdpProductData: function(parentId) {
      var prodTitle = $(parentId).find('.ph-pdp_product_name').text(),
          prodImgSrc = $(parentId).find('#imagePdpPop').val(),
          txtCartBtn = 'CartButton',
          txtAddCartBtn = 'addTo' + txtCartBtn,
          prodCode = $(parentId).find('.' + txtAddCartBtn).val(),
          prodCtv = $(parentId).find('.' + txtAddCartBtn).attr('data-ctv'),
          prodEan = $(parentId).find('.' + txtAddCartBtn).attr('data-ean'),
          prodPrice = $(parentId).find('.ph-pdpprice-value').text();

      $('#ph-interstitial-img').attr('src', prodImgSrc);
      $('#ph-interstitial-title').html(prodTitle);
      $('#ph-interstitial-code').html(' ' + prodCode);
      $('#ph-interstitial-ean').html(' ' + prodEan);
      $('#ph-interstitial-ctv').html(' ' + prodCtv);
      $('#ph-interstitial-price').html(prodPrice);
    },
    loadPopProductData: function(parentId) {
      var prodImgSrc = $(parentId).find('.ph-freqorderedproduct__image').attr('src'),
          txtCartToBtn = 'CartButton',
          txtAddToCartBtn = 'addTo' + txtCartToBtn,
          prodCode = $(parentId).find('.' + txtAddToCartBtn).val(),
          prodCtv = $(parentId).find('.' + txtAddToCartBtn).attr('data-ctv'),
          prodEan = $(parentId).find('.' + txtAddToCartBtn).attr('data-ean'),
          prodTitle = $(parentId).find('.ph-product-summaryinfo:visible').text(),
          prodPrice = $(parentId).find('.ph-prodprice-pop').text();

      $('#ph-interstitial-img').attr('src', prodImgSrc);
      $('#ph-interstitial-title').html(prodTitle);
      $('#ph-interstitial-code').html(' ' + prodCode);
      $('#ph-interstitial-ean').html(' ' + prodEan);
      $('#ph-interstitial-ctv').html(' ' + prodCtv);
      $('#ph-interstitial-price').html(prodPrice);
    },

    pdpAddtoCart: function(productCodeValuehere, qtyValuehere) {
      var txtAddCartPop = 'addtocart-popup',
          addToCartButton = '.ph-pdp-' + txtAddCartPop,
          addToCartLayerIdhere = '#addToCartLayer',
          recomToggleElement = 'm-flag',
          recomdatapart = 'up-flag',
          popFlagVarToggle = $('.ph-reco' + recomToggleElement).attr('data-pop' + recomdatapart);

      $(addToCartLayerIdhere).remove();

      $.ajax({
        url: ACC.config.encodedContextPath + '/cart/add',
        data: {
          productCodePost: productCodeValuehere,
          qty: qtyValuehere
        },
        type: 'POST',
        datatype: 'json',
        success: function(cartResult) {
          var stringEvents = 'events',
              stringTopSection = 'top-section';

          setTimeout(function() {
            $('.ph-interstitial-' + stringTopSection).css('pointer-' + stringEvents, 'auto');
            $('.ph-interstitial-close-btn').css('pointer-' + stringEvents, 'auto');
          }, 2000);

          if (cartResult.miniCartCount > 0) {
            $('#miniCartIcon').html('<div class="quantity-balloon"></div>');
            $('#miniCartIcon .quantity-balloon').html(cartResult.miniCartCount);
            ACC.minicart.$layer.data('needRefresh', true);
          }

          $('#detail-loader').hide();
          $('#detail-wait-message').hide();
          $('.ph-pdp-addtocart-popup').removeClass('ph-disable-button');

          var popFlagVar = $('.ph-recom-flag').attr('data-popup-flag');


          if (popFlagVar === 'false') {
            $('#header').append(cartResult.addToCartLayer);
            clearTimeout(window.sto);

            $(addToCartLayerIdhere).fadeIn(function() {
              $.colorbox.close();

              setTimeout(function() {
                $(addToCartLayerIdhere).fadeOut(function() {
                  $(addToCartLayerIdhere).remove();
                });
              }, 5000);
            });
          } else {
            var stringBtn = 'btn',
                stringPhInterstitialPopup = '.ph-interstitial-popup',
                warningMsgIconhere = '<span class="ph-icon-tick "></span>';

            $('.ph-interstitial-minicart-data').html(cartResult.addToCartLayer);
            $('.ph-interstitial-addingtocart-' + stringBtn).addClass('hidden');

            if ($('.ph-warning').text() === '' && $('.ph-error').text() === '') {
              $(stringPhInterstitialPopup + '-success').removeClass('hidden').html(warningMsgIconhere + $('.ph-interstitial-senddata').text());
            } else {
              ACC.decisionPageInfiniteLoader.checkWarningError();
            }
          }


          $(addToCartButton).attr('disabled', false).removeClass(disableButton);
          $.colorbox.resize();
        },
        error: function() {
          $('#miniCartIcon').html('');
          setTimeout(function() {
            $.colorbox.resize();
          }, 200);
          $.colorbox.close();
          $(addToCartButton).attr('disabled', false).removeClass(disableButton);
        }

      });

      if (popFlagVarToggle === 'true') {
        ACC.interstitialPopUp.recomIntertitialView(productCodeValuehere);
        setTimeout(function() {
          $.colorbox.resize();
        }, 200);
      }
    },

    checkWarningError: function() {
      var stringPhInterstitialPopup = '.ph-interstitial-popup-',
          stringWarning = 'warning',
          stringError = 'error',
          warningMsgIconhere = '<span class="ph-icon-tick "></span>',
          warningErrorIconhere = '<span class="ph-icon-error-red"></span>',
          stringNing = 'ning',
          stringRor = 'ror',
          cboxpopid = 'LoadedContent',
          checkoutmob = 'interstitial-checkout-btnMob',
          continuemob = 'interstitial-continue-btnMob';

      if ($('.ph-war' + stringNing).text() !== '') {
        $(stringPhInterstitialPopup + stringWarning).removeClass('hidden').html(warningMsgIconhere + $('.ph-war' + stringNing).text());
      }

      if ($('.ph-er' + stringRor).text() !== '') {
        $(stringPhInterstitialPopup + stringError).removeClass('hidden').html(warningErrorIconhere + $('.ph-er' + stringRor).text());
      }

      $('.ph-cart-interstitial, #cbox' + cboxpopid + ' .ph-' + checkoutmob + ',#cbox' + cboxpopid + ' .ph-' + continuemob)
        .attr('disabled', false).removeClass('ph-disable-button');
    },
    checkWarningErrorhere: function() {
      var stringPhInterstitialinCheck = '.ph-interstitial',
          stringAtpWarninginCheck = '-popup-warning',
          stringAtpErrorinCheck = '-popup-error',
          warningMsgIconinCheck = '<span class="ph-icon-tick"></span>',
          warningErrorIconinCheck = '<span class="ph-icon-error-red"></span>',
          stringIng = 'ing',
          stringOr = 'or',
          cboxpopid = 'LoadedContent',
          checkoutmob = 'interstitial-checkout-btnMob',
          continuemob = 'interstitial-continue-btnMob';

      if ($('.ph-warn' + stringIng).text() !== '') {
        $(stringPhInterstitialinCheck + stringAtpWarninginCheck).removeClass('hidden').html(warningMsgIconinCheck + $('.ph-warn' + stringIng).text());
      }

      if ($('.ph-err' + stringOr).text() !== '') {
        $(stringPhInterstitialinCheck + stringAtpErrorinCheck).removeClass('hidden').html(warningErrorIconinCheck + $('.ph-err' + stringOr).text());
      }

      $('.ph-cart-interstitial, #cbox' + cboxpopid + ' .ph-' + checkoutmob + ',#cbox' + cboxpopid + ' .ph-' + continuemob)
        .attr('disabled', false).removeClass('ph-disable-button');
    },
    checkProductReco: function() {
      var checkCountVar = $('#cboxLoadedContent .checkCountProd').length,
          loadedContentVar = 'LoadedContent';

      if (checkCountVar > 0) {
        $('#cbox' + loadedContentVar + ' #ph-interstitial-popup-products-added').removeClass('hidden');
      } else {
        $('#cboxLoadedContent #ph-interstitial-popup-products-added').addClass('hidden');
      }
    },
    loadAvailabilitycheck: function(prodCodes, url) {
      var avlstring = '#ph-availb-graph';

      $.ajax({
        type: 'POST',
        url: ACC.config.encodedContextPath + '/asyncproduct/getatpdata',
        dataType: 'json',
        data: {
          code: prodCodes.toString()
        },
        success: function(atpresult) {
          if (atpresult) {
            var $prodRow = $('#decisionpageitem' + atpresult.code),
                prodUrlCheck = ACC.config.encodedContextPath + url + avlstring,
                nobackorderprod = $('.ph-nobackorderprod').val(),
                outofstockdisablebtn = 'ph-outofstockdisablebtn',
                mxStockprod = atpresult.atpData.maxStockQty,
                $backordcountdec = $prodRow.find('.ph-backordermaxcountdec'),
                existingtext = '';

            if (atpresult.atpData.availabilityCode === 'red') {
              $prodRow.addClass('ph-filter-red');
              $prodRow.find('.ph-avail-red').removeClass('hidden');
              $prodRow.find('.ph-avail-red a').attr('href', prodUrlCheck);
              ACC.decisionpage.backorderNotifyCheck($prodRow);
              ACC.decisionPageInfiniteLoader.filterAvailability($prodRow);
            }

            if (atpresult.atpData.availabilityCode === 'green') {
              $prodRow.addClass('ph-filter-green');
              $prodRow.find('.ph-avail-green').removeClass('hidden');
              $prodRow.find('.ph-avail-green a').attr('href', prodUrlCheck);
              existingtext = $backordcountdec.text();
              $backordcountdec.text(existingtext.replace('0', atpresult.atpData.maxStockQty));
              ACC.decisionPageInfiniteLoader.lazycheckquantitystock(mxStockprod, nobackorderprod, outofstockdisablebtn, $prodRow);
            }

            if (atpresult.atpData.availabilityCode === 'orange') {
              $prodRow.addClass('ph-filter-green');
              $prodRow.find('.ph-availCount').html(atpresult.atpData.lowStockQty);
              $prodRow.find('.ph-avail-orange').removeClass('hidden');
              $prodRow.find('.ph-avail-orange a').attr('href', prodUrlCheck);
              existingtext = $backordcountdec.text();
              $backordcountdec.text(existingtext.replace('0', atpresult.atpData.maxStockQty));
              ACC.decisionPageInfiniteLoader.lazycheckquantitystock(mxStockprod, nobackorderprod, outofstockdisablebtn, $prodRow);
            }

            ACC.common.checkForBlockedProducts(atpresult.code);
            $prodRow.find('.' + lazyAddtoCart).removeClass('hidden');
            $prodRow.find('.' + lazyLoadIcon).addClass('hidden');
          }
        }

      });
    },
    createListNameForGa: function() {
      var productListNameForGa = '',
          $isCategoryPage = $('.template-pages-category-productListPage').length,
          $isSearchPage = $('.page-search').length;

      if ($isCategoryPage > 0) {
        productListNameForGa = $(ACC.decisionPageInfiniteLoader.categoryCode).val();
      } else if ($isSearchPage > 0) {
        productListNameForGa = 'search-results';
      }

      return productListNameForGa;
    },
    createURLForGa: function(hiddenVal) {
      var basepath = window.location.protocol + '//' + window.location.host,
          relativePath = window.location.href.replace(basepath, ''),
          relativePathSplitted = relativePath.split('?')[0],
          pageUrl = basepath + relativePathSplitted + '?q=' + hiddenVal,
          clearFilterUrl = pageUrl.split('?q=').splice(1, 1).join(),
          filteredUrl = clearFilterUrl.replaceAll(':', '%3A'),
          newUrl = '',
          searchtext = '';

      if (relativePath.includes('text=')) {
        searchtext = relativePath.split('text=')[1];
        newUrl = basepath + relativePathSplitted + '?q=' + filteredUrl + '&text=' + searchtext;
      } else {
        newUrl = basepath + relativePathSplitted + '?q=' + filteredUrl;
      }

      return newUrl;
    },
    createUserEventObj: function(url, desc, trigger, compname) {
      return {
        url: url,
        description: desc,
        trigger: trigger,
        compname: compname
      };
    },
    commonMaxQtyFlyout: function($productElement, currentDecisionitem) {
      var nobackorderprod = $('.ph-nobackorderprod').val(),
          outofstockdisablebtn = 'ph-outofstockdisablebtn',
          backordermaxtext = $productElement.find('.ph-backordermaxcountdec').html(),
          mxStockprod = backordermaxtext.replace(/\D/g, '');

      if ((currentDecisionitem.find('.ph-avail-orange').is(':visible') && nobackorderprod === 'true') ||
(currentDecisionitem.find('.ph-avail-green').is(':visible') && nobackorderprod === 'true')) {
        currentDecisionitem.find('.ph-pdpquantity').keyup(function() {
          var productQty = $(this).val(),
              productCode = $(this).attr('data-prdcode'),
              isBlocked = '',
              btnWrapStr = 'ph-cartbtn-wrapper';

          isBlocked = ACC.common.isBlockedProduct(productCode);

          if (!isBlocked) {
            if (parseInt(productQty, 10) > parseInt(mxStockprod, 10)) {
              $(this).siblings('.ph-productQtytool').removeClass('hidden');
              $(this).siblings('.' + btnWrapStr).find('.addToCartButton').attr('disabled', 'disabled');
              $(this).siblings('.' + btnWrapStr).find('.ph-addToCartButton .ph-cart').addClass(outofstockdisablebtn);
            } else {
              $(this).siblings('.ph-productQtytool').addClass('hidden');
              $(this).siblings('.' + btnWrapStr).find('.addToCartButton').removeAttr('disabled');
              $(this).siblings('.' + btnWrapStr).find('.ph-addToCartButton .ph-cart').removeClass(outofstockdisablebtn);
            }
          }
        });
      }
    },
    showDealAvailability: function(tmpl, $product) {
      var $dealList = $product.productDealDataList,
          dealsHtml = '';

      for (var listLen = 0; listLen < $dealList.length; listLen = listLen + 1) {
        dealsHtml = dealsHtml + '<li><a href="' + ACC.config.encodedContextPath + '/deals/' + $dealList[listLen].dealNumber + '" title="' + $dealList[listLen].dealShortDesc + '">' + $dealList[listLen].dealShortDesc + '</a></li>';
      }

      if ($dealList.length > 0) {
        tmpl.querySelector('.ph-available-deals-container').classList.remove('ph-d-none');
        tmpl.querySelector('.ph-deals-list-section').innerHTML = dealsHtml;
      }

      return tmpl;
    },
    toggleProductListView: function() {
      var $listviewonly = $('.ph-listview-only'),
          $gridviewonly = $('.ph-gridview-only'),
          decisionItem = '.ph-decisionpage__cards',
          decpagelist = 'ph-decisionpage__list',
          decgrid = 'ph-decisionpage__grid';

      if (localStorage.getItem('viewmode') === 'list') {
        $(decisionItem).addClass(decpagelist);
        $gridviewonly.addClass('hidden');
        $listviewonly.removeClass('hidden');
      } else {
        $(decisionItem).addClass(decgrid);
        $gridviewonly.removeClass('hidden');
        $listviewonly.addClass('hidden');
      }
    }
  };
  window.addEventListener('DOMContentLoaded', function() {
    if ($('.ph-decisionpage__cards').length > 0) {
      ACC.decisionPageInfiniteLoader.bindAll();
    }
  });
})();

$(document).on('click', '.ph-lazyloadpdppagepopup_unused', function() {
  window.sto = setTimeout(function() {
    var popWidth = '',
        stringFlag = 'flag',
        popFlagVar = $('.ph-recom-flag').attr('data-popup-' + stringFlag),
        stringEventshere = 'events',
        localcarttoggle = $('#ph-localcarttoggle').val();

    if (popFlagVar === 'true') {
      popWidth = '795px';
    } else {
      popWidth = '460px';
    }

    if ($(window).width() > 600) {
      $('.ph-interstitial-margin-checkout-btn').removeClass('hidden');
      $('.ph-interstitial-margin-checkout-btnMob').addClass('hidden');
    } else {
      $('.ph-interstitial-margin-checkout-btn').addClass('hidden');
      $('.ph-interstitial-margin-checkout-btnMob').removeClass('hidden');
    }

    $('.ph-interstitial-top-section').css('pointer-' + stringEventshere, 'none');

    if ((popFlagVar === 'true' && localcarttoggle === 'true') || (popFlagVar === 'true' && localcarttoggle === 'false') || (popFlagVar === 'false' && localcarttoggle === 'false')) {
      $.colorbox({
        width: popWidth,
        maxWidth: '90%',
        html: $('.ph-interstitisal').html(),
        overlayClose: false,
        closeButton: false,
        onClosed: function() {
          if (popFlagVar === 'true') {
            $('.ph-recommended-products-desk').addClass('hidden');
            $('.ph-spinnerinterstitial').removeClass('hidden');
            $('.ph-interstitial-addingtocart-btn').removeClass('hidden');
            $('.ph-interstitial-popup-warning').addClass('hidden');
            $('.ph-interstitial-popup-error').addClass('hidden');
            $('.ph-interstitial-popup-success').addClass('hidden');
            ACC.common.refreshScreenReaderBuffer();
          } else {
            ACC.common.refreshScreenReaderBuffer();
          }
        }
      });
    }

    return true;
  }, 300);
});

$(document).on('click', '.ph-addToCartButton,.ph-pdp-addtocart-popup', function(event) {
  var promptClicked = $('.promptClicked').text();

  if (ACC.common.showMixedCartCheck($(this)) === true && promptClicked !== $(this).val()) {
    ACC.common.showzoomDeliveredPopUp($(this).val());
    event.preventDefault();
    event.stopImmediatePropagation();
  } else if (promptClicked !== '' && promptClicked !== $(this).val()) {
    $('.promptClicked').text('');
  }
});
$(document).on('click', '.ph-pdp-addtocart-popup', function() {
  var qtyValue = $('#addToCartForm' + $(this).val()).find('.' + ACC.common.pdpQuantityCls).val(),
      productCodeValue = $(this).val(),
      productCtvvalue = $(this).attr('data-ctv'),
      pdpAddToCartBtn = '.ph-pdp-addtocart-popup',
      pdpDescriptionMain = '.ph-pdp_product_description_main',
      productsItemPdp = '',
      products = [],
      price = '',
      txtPdpPriceVal = 'ph-pdpprice-value';

  if (window.eddlContext.locale.currency === 'THB') {
    price = $(pdpAddToCartBtn).parents(pdpDescriptionMain).find('.' + txtPdpPriceVal).text().replace(/,/g, '');
  } else {
    price = $(pdpAddToCartBtn).parents(pdpDescriptionMain).find('.' + txtPdpPriceVal).text().replace(/,(?=[^,]*$)/, '.');
  }

  ACC.decisionPageInfiniteLoader.pdpAddtoCart(productCodeValue, qtyValue);

  if (productCtvvalue !== '') {
    productsItemPdp = ACC.googleanalytics.createProductListForGa(productCtvvalue, qtyValue, price);
  } else {
    productsItemPdp = ACC.googleanalytics.createProductListForGa(productCodeValue, qtyValue, price);
  }

  products.push(productsItemPdp);
  ACC.googleanalytics.gaAddtocart('product-detail', products);
});

$(document).on('click', '.ph-addToCartButton', function() {
  var qtyVal = $('#addToCartForm' + $(this).val()).find('.' + ACC.common.pdpQuantityCls).val(),
      txtToCartBtn = 'ToCartButton',
      addToCartButton = '.ph-add' + txtToCartBtn,
      addToCartLayerId = '#addToCartLayer',
      prodCodeValue = $(this).val(),
      productCtvvalue = $(this).attr('data-ctv'),
      elementId = '',
      stringRow = 'row-',
      stringPlRow = 'pl-row-',
      price = '',
      productItem = '',
      products = [],
      listName = '',
      disableCart = 'ph-cart-disable',
      txtProdPrice = 'ph-prodprice-pop',
      txtDecPageProdVal = '#decisionpageitem' + prodCodeValue,
      recomToggleElement = 'm-flag',
      recomdatapart = 'up-flag',
      popFlagVarToggle = $('.ph-reco' + recomToggleElement).attr('data-pop' + recomdatapart),
      cboxpopid = '#cboxLoadedContent ',
      checkbutmob = '.ph-interstitial-checkout-btnMob',
      continuebutmob = '.ph-interstitial-continue-btnMob',
      cartintert = 'cart-interstitial';


  $(addToCartLayerId).remove();

  if ($('#ph-pl-' + stringRow + prodCodeValue).length > 0) {
    elementId = '#ph-' + stringPlRow + prodCodeValue;
  }

  if ($(txtDecPageProdVal).length > 0) {
    elementId = txtDecPageProdVal;
  }

  ACC.decisionPageInfiniteLoader.loadPopProductData(elementId);

  if (window.eddlContext.locale.currency === 'THB') {
    price = $(elementId).find('.' + txtProdPrice).text().replace(/,/g, '');
  } else {
    price = $(elementId).find('.' + txtProdPrice).text().replace(/,(?=[^,]*$)/, '.');
  }

  $(addToCartButton).attr('disabled', true);
  $('.ph-cart').addClass(disableCart);
  // Interstitial call
  setTimeout(function() {
    $('.ph-' + cartintert + ',' + cboxpopid + checkbutmob + ',' + cboxpopid + continuebutmob)
      .attr('disabled', 'disabled').addClass('ph-disable-button');
  }, 900);
  $.ajax({
    url: ACC.config.encodedContextPath + '/cart/add',
    data: {
      productCodePost: $(this).val(),
      qty: qtyVal
    },
    type: 'POST',
    datatype: 'json',
    success: function(cartResult) {
      var stringSection = 'section';

      $('.ph-' + cartintert + ',' + cboxpopid + checkbutmob + ',' + cboxpopid + continuebutmob)
        .attr('disabled', false).removeClass('ph-disable-button');
      setTimeout(function() {
        $('.ph-interstitial-top-' + stringSection).css('pointer-events', 'auto');
        $('.ph-interstitial-close-btn').css('pointer-events', 'auto');
      }, 2000);

      if (cartResult.miniCartCount > 0) {
        var stringCartIcon = 'CartIcon';

        $('#mini' + stringCartIcon).html('<div class="quantity-balloon"></div>');
        $('#miniCartIcon .quantity-balloon').html(cartResult.miniCartCount);
        ACC.minicart.$layer.data('needRefresh', true);
      }

      var stringOmFlag = 'om-flag',
          stringPopFlag = 'popup-flag',
          popFlagVar = $('.ph-rec' + stringOmFlag).attr('data-' + stringPopFlag);


      if (popFlagVar === 'false') {
        $('#header').append(cartResult.addToCartLayer);
        clearTimeout(window.sto);

        $(addToCartLayerId).fadeIn(function() {
          $.colorbox.close();

          setTimeout(function() {
            $(addToCartLayerId).fadeOut(function() {
              $(addToCartLayerId).remove();
            });
          }, 5000);
        });
      } else {
        var stringAddtoCartBtn = 'addingtocart-btn',
            stringPhInterstitial = '.ph-interstitial-',
            warningMsgIcon = '<span class="ph-icon-tick"></span>';

        $('.ph-' + cartintert + ',' + cboxpopid + checkbutmob + ',' + cboxpopid + continuebutmob)
          .attr('disabled', false).removeClass('ph-disable-button');

        $('.ph-interstitial-minicart-data').html(cartResult.addToCartLayer);
        $(stringPhInterstitial + stringAddtoCartBtn).addClass('hidden');

        if ($('.ph-warning').text() === '' && $('.ph-error').text() === '') {
          $(stringPhInterstitial + 'popup-success').removeClass('hidden').html(warningMsgIcon + $('.ph-interstitial-senddata').text());
        } else {
          ACC.decisionPageInfiniteLoader.checkWarningErrorhere();
        }
      }

      $(addToCartButton).attr('disabled', false);
      $('.ph-cart').removeClass(disableCart);
      $('.ph-outofstockdisablebtn').parent().attr('disabled', 'disabled');
      setTimeout(function() {
        $.colorbox.resize();
      }, 200);
    },
    error: function() {
      var stringniCartIcon = 'niCartIcon';

      $('#mi' + stringniCartIcon).html('');
      setTimeout(function() {
        $.colorbox.resize();
      }, 200);
      $.colorbox.close();
      $('.ph-' + cartintert + ',' + cboxpopid + checkbutmob + ',' + cboxpopid + continuebutmob)
        .attr('disabled', false).removeClass('ph-disable-button');
      $(addToCartButton).attr('disabled', false);
      $('.ph-cart').removeClass(disableCart);
    }
  });

  if (popFlagVarToggle === 'true') {
    ACC.interstitialPopUp.recomIntertitialView($(this).val());
    setTimeout(function() {
      $.colorbox.resize();
    }, 200);
  }

  listName = ACC.decisionPageInfiniteLoader.createListNameForGa();

  if (productCtvvalue !== '') {
    productItem = ACC.googleanalytics.createProductListForGa(productCtvvalue, qtyVal, price);
  } else {
    productItem = ACC.googleanalytics.createProductListForGa(prodCodeValue, qtyVal, price);
  }

  products.push(productItem);
  ACC.googleanalytics.gaAddtocart(listName, products);
});
$(document).on('click', '.ph-addToCartButtonInterstitial', function() {
  var buttonInterstitialVar = 'ButtonInterstitial',
      codeVar = 'code-',
      interstitialToggleVar = 'InterstitialToggle';

  $('#prod' + codeVar + $(this).val() + ' .ph-addToCart' + buttonInterstitialVar).addClass('hidden');
  $('#prod' + codeVar + $(this).val() + ' .ph-addToCartButton' + interstitialToggleVar).removeClass('hidden').addClass('checkCountProd');

  ACC.decisionPageInfiniteLoader.checkProductReco();
});
$(document).on('change', '.ph-facetscat__input, .ph-facetsubcategories', function() {
  var parentVal = $(this).parents('.ph-facetcat__form, .ph-facetsubcat__form'),
      inputField = 'input:',
      $checkboxes = parentVal.find(inputField + 'checkbox'),
      hiddenVal = parentVal.find('input:hidden').val(),
      urlLink = ACC.decisionPageInfiniteLoader.createURLForGa(hiddenVal),
      desc = parentVal.find('label').find('.ph-facetlabel').text(),
      trigger = 'linkCategory.clickFilter',
      compname = parentVal.find(inputField + 'checkbox').attr('id'),
      userEventObj = '';

  if ($checkboxes.is(':checked')) {
    userEventObj = ACC.decisionPageInfiniteLoader.createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  }
});
$(document).on('click', '.ph-addToCartButtonInterstitialToggle', function() {
  $('#prodcode-' + $(this).val() + ' .ph-addToCartButtonInterstitialToggle').addClass('hidden').removeClass('checkCountProd');
  $('#prodcode-' + $(this).val() + ' .ph-addToCartButtonInterstitial').removeClass('hidden');
  $('#cboxLoadedContent #ph-interstitial-popup-products-added').addClass('hidden');

  ACC.decisionPageInfiniteLoader.checkProductReco();
});

$(document).on('click', '.ph-viewtoggle', function() {
  ACC.decisionPageInfiniteLoader.toggleProductListView();
});

$(document).on('touchstart touchend', '.ph-device-rating', function(event) {
  if ($(window).width() > 900) {
    event.preventDefault();
    $(this).first().parents().eq(2).find('.ph-ratingPopup').toggle();
  }
});
$(document).on('click', '.ph-notifyme-button', function() {
  var prodCode = $(this).data('id'),
      prodlayer = '',
      notifybuttn = 'notifybut',
      disbut = 'disable-button',
      decisionEle = 'decisionpageitem',
      rowString = '-row-',
      txtNotifyProd = 'ph-notify-prodid';

  $('.ph-notifyprodcontent').html('');
  $('#' + txtNotifyProd).val(prodCode);

  if ($('#ph-pl-row-' + prodCode).length > 0) {
    prodlayer = $('#ph-pl' + rowString + prodCode).find('.ph-decision-page__topcontent').clone();
  }

  if ($('#' + decisionEle + prodCode).length > 0) {
    prodlayer = $('#' + decisionEle + prodCode).find('.ph-decision-page__topcontent').clone();
  }

  $('.ph-notifyprodcontent').html(prodlayer);
  $('.ph-' + notifybuttn).removeClass('ph-' + disbut);
  $.colorbox({
    width: '390px',
    maxWidth: '90%',
    height: 'auto',
    html: $('.ph-notifypop').html(),
    overlayClose: true
  });
  $('.ph-notifypopContent .ph-regforminput').trigger('keyup');
});

/* Default quantity value is set to 1 for both decesion and PDP page */

$(document).on('change', '#cboxLoadedContent .ph-notifypopContent', function() {
  var productCode = $('#ph-notify-prodid').val(),
      decQtyValue = $('#cboxLoadedContent .ph-notifyquantity').attr('id', 'ph-decQty-' + productCode).val(),
      notify = 'notifyquantity',
      newPh = 'ph-';

  if (decQtyValue === '0' || decQtyValue === '') {
    $('#cboxLoadedContent .ph-' + notify).val('1');
  } else {
    $('#cboxLoadedContent .ph-' + notify).attr('id', newPh + 'decQty-' + productCode).val();
  }
});
$(document).on('click', '.ph-notifybut', function() {
  var prodcode = $('#ph-notify-prodid').val(),
      decQtyVal = $('#cboxLoadedContent .ph-notifyquantity').attr('id', 'ph-decQty-' + prodcode).val(),
      email = $('#cboxLoadedContent .ph-emailAddress').val();

  ACC.decisionpage.backorderNotifyEmailtrigger(prodcode, email, decQtyVal);
});

$(document).on('keyup', '.ph-notifypopContent .ph-regforminput', function() {
  var emailValue = $(this).val(),
      notifybutton = '.ph-notifybut',
      disablebutton = 'disable-button',
      notifyemailElement = '#cboxLoadedContent .ph-notifypopContent .ph-inputData';

  if (ACC.contactpagebuttons.email(emailValue)) {
    $(notifyemailElement).find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $(notifyemailElement).find('.ph-email__emptyvalue').text($(notifyemailElement).attr('data-emptyContent')).addClass('ph-redalert-msg');
    $(notifybutton).addClass('ph-' + disablebutton);
  } else {
    $(notifyemailElement).find('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
    $(notifyemailElement).find('.ph-email__emptyvalue').text('').removeClass('ph-redalert-msg');
    $(notifybutton).removeClass('ph-' + disablebutton);
  }
});

$(document).on('change', '#ph-filter-Availability', function() {
  var urlLink = window.location.href,
      parentVal = $(this).parents('#ph-nav-avail-filter'),
      desc = parentVal.find('label').find('.ph-facetlabel').text().trim(),
      trigger = 'linkCategory.clickFilter',
      compname = parentVal.find('input:checkbox').attr('id'),
      userEventObj = '';

  if ($(this).parents('.ph-filter-popup').length > 0) {
    setTimeout(function() {
      $('.ph-filter-popup-close').trigger('click');
      ACC.decisionPageInfiniteLoader.filterAvailabilityEnableDisable();
    }, 200);
  } else {
    ACC.decisionPageInfiniteLoader.filterAvailabilityEnableDisable();
  }

  if ($(ACC.decisionPageInfiniteLoader.inStockChkBox).prop(ACC.decisionPageInfiniteLoader.isChecked)) {
    userEventObj = ACC.decisionPageInfiniteLoader.createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  }
});
$(document).on('click', '.ph-ratings-okbutton', function() {
  var ratingUrl = $('.ph-ratings-okbutton').attr('data-navurl');

  $.colorbox.close();
  window.open(ratingUrl, '_blank');
});
$(document).ajaxStop(function() {
  var enableNewType = false,
      categoryCode = $(ACC.decisionPageInfiniteLoader.categoryCode).val(),
      pageitem = 'isionpage__item';

  enableNewType = ACC.decisionPageInfiniteLoader.loadProductCardAfterAjax();

  if ($(ACC.decisionPageInfiniteLoader.inStockChkBox).prop(ACC.decisionPageInfiniteLoader.isChecked) && enableNewType) {
    $('.ph-dec' + pageitem + '.ph-filter-green').addClass(ACC.decisionPageInfiniteLoader.phdflexCls);
    $('.ph-dec' + pageitem + '.ph-filter-green').removeClass(ACC.decisionPageInfiniteLoader.phdnoneCls);
    $('.ph-instock-loader').addClass('hidden');
    ACC.decisionPageInfiniteLoader.intObs.show();
    ACC.decisionPageInfiniteLoader.isProductCardEmpty();
  }

  if (categoryCode === 'PromotionalCategory') {
    $(ACC.decisionPageInfiniteLoader.productCards).removeClass('ph-card-delay');


    $('.ph-decisionpage__item:visible').each(function(index, item) {
      var prodCode = $(item).attr('id').split('ph-pl-row-'),
          $currentDecisionitem = $(this),
          $productElement = $('#ph-pl-row-' + prodCode[1]);

      ACC.decisionPageInfiniteLoader.commonMaxQtyFlyout($productElement, $currentDecisionitem);
    });
  }
});

$(document).on('click', '.ph-deal-ribbon', function() {
  var $dealRibbon = $(this),
      $dealRibbonParent = $dealRibbon.parent(),
      $dealList = $dealRibbonParent.find('.ph-available-deals-list'),
      $allAvailableDealListSection = $('.ph-available-deals-list');

  $allAvailableDealListSection.each(function() {
    $(this).addClass('hidden');
    $(this).siblings('.ph-deal-ribbon').removeClass('ph-deal-open');
  });
  $dealRibbon.addClass('ph-deal-open');
  $dealList.removeClass('hidden');
});

$(document).on('click', function(event) {
  var $allAvailableDealListSection = $('.ph-available-deals-list'),
      $clickedElem = $(event.target);

  // eslint-disable-next-line require-jsdoc
  function checkRibbonEle($targetEle) {
    if ($targetEle.hasClass('ph-deal-ribbon') || $targetEle.parent().hasClass('ph-deal-ribbon') || $targetEle.parent().parent().hasClass('ph-deal-ribbon')) {
      return true;
    }

    return false;
  }

  $allAvailableDealListSection.each(function() {
    if (!checkRibbonEle($clickedElem)) {
      $(this).addClass('hidden');
      $(this).siblings('.ph-deal-ribbon').removeClass('ph-deal-open');
    }
  });
});
/* eslint-enable max-lines */
/* eslint-enable max-lines-per-function */
/* eslint-enable max-len */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable vars-on-top */
/* eslint-enable max-statements*/
/* eslint-enable  no-negated-condition */
/* eslint-enable  dollar-sign/dollar-sign */
